(function () {
  'use strict';

  const PACK_ID = '_Pack ID';
  const PACK_SIZE = '_Pack Size';
  const GIFT_FOR_PACK = '_Gift for Pack';

  function routesRoot() {
    return window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
      ? Shopify.routes.root
      : '/';
  }

  function sectionsToRender() {
    try {
      return window.Alpine && Alpine.store('xCartHelper')
        ? Alpine.store('xCartHelper')
            .getSectionsToRender()
            .map((section) => section.id)
        : [];
    } catch (error) {
      return [];
    }
  }

  async function getCart() {
    const response = await fetch(routesRoot() + 'cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to read cart');
    }

    return response.json();
  }

  function validateCart(cart) {
    const packs = {};

    cart.items.forEach((item) => {
      const properties = item.properties || {};
      const packId = properties[PACK_ID];

      if (!packId) return;

      if (!packs[packId]) {
        packs[packId] = {
          expected: 0,
          selected: 0
        };
      }

      const sizeMatch = String(
        properties[PACK_SIZE] || ''
      ).match(/\d+/);

      if (sizeMatch) {
        packs[packId].expected = Number(sizeMatch[0]);
      }

      /*
       * El regalo pertenece visualmente al pack,
       * pero no cuenta como una de las 12 galletas.
       */
      if (!properties[GIFT_FOR_PACK]) {
        packs[packId].selected += Number(item.quantity || 0);
      }
    });

    const invalidPacks = Object.entries(packs).filter(
      (entry) => {
        const pack = entry[1];

        return (
          ![6, 12].includes(pack.expected) ||
          pack.selected !== pack.expected
        );
      }
    );

    return {
      valid: invalidPacks.length === 0,
      invalidPacks: invalidPacks
    };
  }

  async function removePack(packId, button) {
    if (!packId || window.BellsBundleCart.loading) {
      return;
    }

    window.BellsBundleCart.loading = true;

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    try {
      const cart = await getCart();
      const updates = {};

      /*
       * Busca todas las líneas con el mismo Pack ID
       * y las establece en cantidad cero.
       */
      cart.items.forEach((item) => {
        const properties = item.properties || {};

        if (properties[PACK_ID] === packId) {
          updates[item.key] = 0;
        }
      });

      if (!Object.keys(updates).length) {
        return;
      }

      const payload = {
        updates: updates
      };

      const sections = sectionsToRender();

      if (sections.length) {
        payload.sections = sections;
        payload.sections_url = window.location.pathname;
      }

      const response = await fetch(
        routesRoot() + 'cart/update.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(payload)
        }
      );

      if (!response.ok) {
        throw new Error('Unable to remove pack');
      }

      await response.json();

      /*
       * El servidor ya confirmó la eliminación completa. Recargar evita
       * estados desincronizados entre el cart drawer y la página /cart.
       */
      window.location.reload();
    } catch (error) {
      window.alert(
        'We could not remove the complete cookie box. Please refresh the page and try again.'
      );
    } finally {
      window.BellsBundleCart.loading = false;

      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  }

  async function protectCheckout(event) {
    const checkoutControl = event.target.closest(
      'button[name="checkout"], ' +
      'input[name="checkout"], ' +
      'a[href*="/checkout"]'
    );

    if (
      !checkoutControl ||
      checkoutControl.dataset.bundleValidated === 'true'
    ) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    try {
      if (window.BellsPromoGift) {
        await window.BellsPromoGift.sync();
      }
      const cart = await getCart();
      const result = validateCart(cart);

      if (!result.valid) {
        window.alert(
          'Your cookie box is incomplete. Remove the incomplete box and build a new box of 6 or 12 cookies before checkout.'
        );

        return;
      }

      checkoutControl.dataset.bundleValidated = 'true';

      if (checkoutControl.tagName === 'A') {
        window.location.href = checkoutControl.href;
      } else if (checkoutControl.form) {
        checkoutControl.form.requestSubmit(
          checkoutControl
        );
      } else {
        checkoutControl.click();
      }
    } catch (error) {
      window.alert(
        'We could not validate your cookie box. Please refresh the page and try again.'
      );
    }
  }

  window.BellsBundleCart = {
    loading: false,
    removePack: removePack,
    validateCart: validateCart
  };

  /*
   * Listener delegado: también funciona cuando Shopify vuelve a renderizar
   * el cart drawer después de agregar productos.
   */
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-bells-remove-pack]');

    if (!button) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    removePack(button.dataset.bellsPackId, button);
  }, true);

  document.addEventListener(
    'click',
    protectCheckout,
    true
  );
})();
